<script lang="ts">
  import { onMount } from "svelte";
  import { draw, fade } from "svelte/transition";

  export let frequency = 0.7;
  export let strokeWidth = 1.25;
  export let continuous = true;

  let show = false;

  const animate = () => {
    show = !show;
    if (continuous) setTimeout(animate, 1000 / frequency);
  };
  onMount(animate);
</script>

{#if show}
  <!-- Animate the Outverse O by FREQUENCY draws per second -->
  <!-- Draws the paths on the IN transition, and fades OUT -->
  <!-- Fades out slightly faster, to create a momentary dark period for effect. -->
  <svg
    class="text-neutral-500 dark:text-neutral-300"
    width="100%"
    height="100%"
    viewBox="0 0 388 388"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      in:draw|global={{ duration: 1000 / frequency }}
      out:fade={{ duration: (1000 / frequency) * 0.85 }}
      d="M88.286 91.519c0-18.88 7.673-35.973 20.019-48.357 12.383-12.345 29.477-20.018 48.357-20.018h129.153c41.975 0 75.972 33.997 75.972 75.972V228.27c0 18.879-7.673 35.973-20.018 48.356l-67.806 67.768c12.004-12.308 19.449-29.174 19.449-47.749v-167.14c0-20.968-17.018-37.986-37.986-37.986H88.286Z"
      stroke="currentColor"
      stroke-width={strokeWidth}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      in:draw|global={{ duration: 1000 / frequency }}
      out:fade={{ duration: (1000 / frequency) * 0.85 }}
      d="M293.587 296.133c0 18.88-7.673 35.973-20.019 48.357-12.383 12.345-29.477 20.019-48.356 20.019H96.058c-41.975 0-75.972-33.998-75.972-75.973V159.383c0-18.879 7.673-35.973 20.018-48.357l67.806-67.767C95.906 55.566 88.461 72.432 88.461 91.007v167.14c0 20.969 17.018 37.986 37.986 37.986h167.14Z"
      stroke="currentColor"
      stroke-width={strokeWidth}
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
{/if}
